/**
 * Stable empty defaults used as initial prop values in DataGrid. Defined as module-level
 * constants so React doesn't create new references on every render, preventing unnecessary
 * re-renders from TanStack Table's state comparisons. Internal to the DataGrid module.
 */
/** Default column visibility — all columns visible. */
export const EMPTY_COLUMN_VISIBILITY = {};
/** Default column filters — no filters applied. */
export const EMPTY_COLUMN_FILTERS: never[] = [];
/** Default sorting state — no columns sorted. */
export const EMPTY_SORTING: never[] = [];
/** Column ID for the controls column (row selection checkbox + expand trigger). */
export const CONTROLS_COLUMN_ID = '_controls';
